import { inject, Injectable } from '@angular/core';

import { useBackendVersionStore } from '../../+state/version/backend-version-api.store';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentBuildInfoService {
  private store = inject(useBackendVersionStore);

getBackendVersion() {
    return this.store.loadBackendVersion();
  }
}
